import { render, staticRenderFns } from "./mark-as-endorsed.vue?vue&type=template&id=d584a784&scoped=true&"
import script from "./mark-as-endorsed.vue?vue&type=script&lang=js&"
export * from "./mark-as-endorsed.vue?vue&type=script&lang=js&"
import style0 from "./mark-as-endorsed.vue?vue&type=style&index=0&id=d584a784&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d584a784",
  null
  
)

export default component.exports